import React, {Component} from 'react';
import PropTypes from "prop-types";
import "react-modal-video/css/modal-video.min.css";
import planDeActivitateCasaMaria from "../plan_de_activitate_casa_maria.pdf";
import raportActivitate2024 from '../raport_activitate_2024.pdf';
import raportActivitate2025 from '../raport_activitate_2025.pdf';

class Reports extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      didViewCountUp: false
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({isOpen: true});
  }

  onVisibilityChange = isVisible => {
    if (isVisible) {
      this.setState({didViewCountUp: true});
    }
  };

  render() {
    return (
      <React.Fragment>
        <section id="reports" className="info-area info-bg">
          <div className="diplay-table">
            <div className="display-table-cell">
              <div className="video-inner-content">
                <div className="row">
                  <div className="col-lg-5 col-md-3 offset-lg-3">
                    <div className="text-left font-black vertical-align">
                      <div className="row">
                        <div className="col-md-12">
                          <h2>Rapoarte:</h2>
                          <ul className="list-style">
                            <li>
                              <a href={planDeActivitateCasaMaria} target="_blank" title="Plan de activitate Asociatia Casa Maria">
                                <span>Plan de activitate <strong>Asociatia Casa Maria</strong></span>
                              </a>
                            </li>
                            <li>
                              <a href={raportActivitate2024} target="_blank" title="Raport activitate 2024">
                                <span>Raport activitate 2024</span>
                              </a>
                            </li>
                            <li>
                              <a href={raportActivitate2025} target="_blank" title="Raport activitate 2025">
                                <span>Raport activitate 2025</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

Reports.propTypes = {
  Title: PropTypes.string,
  Content: PropTypes.string,
}
Reports.defaultProps = {
  Title: "Watch Video",
  Content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fermentum sagittis nulla, non vehicula mauris rutrum vitae. Sed non consequat dolor",
}
export default Reports;
